module.exports = (__webpack_require__(253824))(961);